/* eslint-disable no-script-url */
import { Button } from "@material-ui/core";
import OpenInNewOutlined from "@material-ui/icons/OpenInNewOutlined";
import React from "react";
import CopyText from "../components/CopyText";

export default function LinkText(props) {
  return (
    <>
      <CopyText url={props.url} />
      {props.url.length > 0 ? (
        <Button style={{ marginLeft: 0, minHeight: 0, minWidth: 0 }}>
          <a href={props.url.startsWith("http") === true ? props.url : "https://" + props.url} target="_blank" rel="noopener noreferrer">
            <OpenInNewOutlined />
          </a>
        </Button>
      ) : null}
    </>
  );
}
